import React from 'react'
import { cn } from '@/lib/utils'

interface FilterItemProps {
  /**
   * Icon to display next to the title
   */
  icon: React.ReactNode
  /**
   * Title of the filter section
   */
  title: string
  /** The filter component's children will show selection */
  /**
   * Filter component to render (select, searchable select, etc.)
   */
  children: React.ReactNode
  /**
   * Optional className for the container
   */
  className?: string
}

/**
 * FilterItem - Individual filter section with icon, title, label and scrollable options
 *
 * Usage:
 * ```tsx
 * <FilterItem
 *   icon={<Building2 className="h-4 w-4" />}
 *   title="Compañía"
 *   label="Seleccionar compañía proveedora"
 * >
 *   <SearchableSelectExpanded ... />
 * </FilterItem>
 * ```
 */
export function FilterItem({
  icon,
  title,
  children,
  className,
}: FilterItemProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-start gap-4 self-stretch py-4',
        className
      )}
    >
      {/* Icon + Title */}
      <div className="flex items-center gap-2">
        <div className="text-gray-500">{icon}</div>
        <h3 className="text-sm font-semibold leading-5 text-[#171717]">
          {title}
        </h3>
      </div>

      {/* Selected Value Display / Label */}
      {/* Filter Component (no selected label above) */}

      {/* Filter Component */}
      <div className="w-full">{children}</div>
    </div>
  )
}
